import { Component } from '@angular/core';

@Component({
	selector: 'app-starwish-loading',
	templateUrl: `./starwishLoading.component.html`,
	styleUrls: ['./starwishLoading.component.scss']
})

export class StarwishLoadingComponent {
	public zIndex: number = 999;

	constructor() {
	}
}
